import { render, staticRenderFns } from "./billing-plans-comparing-table.vue?vue&type=template&id=8247b3bc&scoped=true&lang=pug"
import script from "./billing-plans-comparing-table.vue?vue&type=script&lang=js"
export * from "./billing-plans-comparing-table.vue?vue&type=script&lang=js"
import style0 from "./billing-plans-comparing-table.vue?vue&type=style&index=0&id=8247b3bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8247b3bc",
  null
  
)

export default component.exports